<div class="loader-container" *ngIf="showLoader">
  <div class=" loader"></div>
</div>
<div class="form"
  style="width:100%; height: 100%; float: left; overflow: hidden; display: flex;flex-direction: column;justify-content: space-between;">
  <div>
    <app-header #header [exportar]="false" [buscador]="true" [filtro]="true" [resetFiltro]="true"
      (eventFilter)="eventFilter()" (eventResetFilter)="eventResetFilter()" (eventExportar)="onExportar()"
      (eventBuscador)="onBuscar()">
    </app-header>
  </div>
  <div style="width: 100%; height: calc(100% - 20px);">
    <jqxGrid #grid [theme]="environment.tema" [width]="'100%'" [height]="'100%'" [source]="dataAdapter" [appCellClick]
      [columnsresize]="true" [localization]="langGrid" [filterable]="true" [showfilterrow]="false"
      [selectionmode]="'checkbox'" [columns]="columns" [showrowlines]="false" [showcolumnlines]="true"
      [enablebrowserselection]="true" [pageable]="false" [sortable]="true" [altrows]="true" [showstatusbar]="true"
      [statusbarheight]="20" [showaggregates]="true" [rowsheight]="30" [filterrowheight]="25" [columnsheight]="25"
      [enabletooltips]="false" [editable]="false" [filtermode]="'default'" [columngroups]="columngroups"
      [filter]="filter" [updatefilterconditions]="updatefilterconditions" (onBindingcomplete)="onBindingComplete()"
      (onRowdoubleclick)="onRowDoubleClick($event)">
    </jqxGrid>
  </div>
</div>

<div #formMovil></div>
